import { useMemo } from "react";
import { getFormattedCurrency } from "../../../lib/currencyFormatter";

type ParameterValueFormatter = (value: any) => string;

type ParameterTypeMapItem = {
  key: string;
  displayLabel: string;
  valueFormatter?: ParameterValueFormatter;
};

const currencyFormatter: ParameterValueFormatter = (value) => {
  return getFormattedCurrency(value);
};

export const useParameterTypesMap = () => {
  const parameterTypesMap = useMemo<ParameterTypeMapItem[]>(
    () => [
      {
        key: "billAmount",
        displayLabel: "Bill Amount",
        valueFormatter: currencyFormatter
      },
      {
        key: "impoundBalance",
        displayLabel: "Impound Balance",
        valueFormatter: currencyFormatter
      }
    ],
    []
  );

  const getParameterType = (key: string) => parameterTypesMap.find((item) => item.key === key);

  return { parameterTypesMap, getParameterType };
};
